import { Row } from "@commonlibs";
import styled, { css } from "styled-components";

export const TextFieldRow = styled(Row)(
    () => css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 20px;
    `,
);

export const IdentificationInputContainer = styled.div(
    () => css`
        position: relative;
    `,
);

export const SpinnerWrapper = styled.div(
    () => css`
        position: absolute;
        top: 80%;
        transform: translateY(-80%);
        right: 12px;
        z-index: 10;
    `,
);
